module.exports = __webpack_public_path__ + "img/money-peak-full-white-logo.31a1f97.png";